/**
 * 专利卫士 预审优审中心信息
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>预(优)审中心</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.city" style="width:160px" placeholder="输入城市名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-select size="small" v-model="formInline.category" style="width:100px" placeholder="请选择">
          <el-option v-for="type in countryType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="80">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="名称" min-width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="category" align="center" label="分类" width="80" :formatter="typeFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="city" align="center" label="省份" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="area" align="center" label="领域" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" align="center" label="联系电话" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" align="center" label="联系地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="ipc_num" align="center" width="60" label="IPC" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleIpc(scope.$index, scope.row)">分类号</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delCountry(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="warning" @click="handleDoc(scope.$index, scope.row)">文档管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-form-item label="中心名称" prop="name">
          <el-input size="small" v-model="infoForm.name" placeholder="请输入中心名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属城市" prop="city">
          <el-input size="small" v-model="infoForm.city" placeholder="请输入所属城市" clearable></el-input>
        </el-form-item>
        <el-form-item label="开放领域" prop="area">
          <el-input size="small" v-model="infoForm.area" placeholder="请输入开放领域" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input size="small" v-model="infoForm.address" placeholder="请输入联系地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input size="small" v-model="infoForm.tel" placeholder="请输入联系电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属分类" prop="category">
          <el-radio-group type="kind" v-model="infoForm.category"> 
              <el-radio v-model="infoForm.category" label="pre" style="font-size: 25px">预审</el-radio>
              <el-radio v-model="infoForm.category" label="exc">优审</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCountry('infoForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 文档管理 -->
    <el-dialog :title="title" :visible.sync="docFormVisible" width="50%" @click="closeDialog('docForm')">
      <el-button title="新增文档" type="primary" style="float: right;margin-right: 10px;margin-top: -30px;margin-bottom: 10px;" @click="handleDocEdit">添加</el-button>
      <el-table size="small" :data="docData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
        <el-table-column align="center" type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="doc_id" v-if="idShow">
        </el-table-column>
        <el-table-column prop="name" align="center" label="文档名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="type" align="center" label="文档类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDocEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delCenterDoc(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="warning" @click="viewDoc(scope.$index, scope.row)">查看</el-button>
          </template>
      </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 文档编辑 -->
    <el-dialog :title="title" :visible.sync="editDocFormVisible" width="30%" @click="closeDialog('editDocForm')">
      <el-form label-width="120px" :model="editDocForm" ref="editDocForm" :rules="editDocFormRules">
        <el-form-item label="文档名称" prop="name">
          <el-input size="small" v-model="editDocForm.name" placeholder="请输入文档名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="文档类型" prop="type">
          <el-input size="small" v-model="editDocForm.type" placeholder="请输入文档类型" clearable></el-input>
        </el-form-item>
        <el-form-item label="文档地址" prop="url">
          <el-upload
          class="upload-demo"
              :data="uploadDocParam"
              :action=uploadExcel
              :headers=setHeader
              :before-upload="beforeAvatarVideoUpload"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :show-file-list="false"
              multiple>
            <el-input size="small" v-model="editDocForm.url" placeholder="请输入文档地址" disabled>
              <el-button slot="append">上传</el-button>
            </el-input>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveDoc('editDocForm')">提交</el-button>
          <el-button @click="closeEditDoc()">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- IPC分类号管理 -->
    <el-dialog :title="title" :visible.sync="ipcFormVisible" width="60%">
      <el-upload
          style="float: right;margin-top: -30px;margin-bottom: 10px;"
          class="upload-demo"
              :data="uploadIpcParam"
              :action=uploadIpc
              :headers=setHeader
              :before-upload="beforeAvatarVideoUpload"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :on-success="handleIpcSuccess"
              :show-file-list="false"
              multiple>
        <el-button title="导入分类号数据" type="primary" >导入</el-button>
      </el-upload>
      <el-button title="清除该中心所有分类号数据" style="float: right;margin-right: 10px;margin-top: -30px;margin-bottom: 10px;" @click="delIpcData">清除</el-button>
      <el-table size="small" :data="ipcData" v-loading="loading" border element-loading-text="拼命加载中" height="460" style="width: 100%;" tooltip-effect="dark">
        <el-table-column align="center" type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="id" v-if="idShow">
        </el-table-column>
        <el-table-column prop="ipc" align="center" label="分类号" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="desc" label="分类描述" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { 
  delCountry, 
  wechatUrl, 
  getPreExaminePageList, 
  editPreExamine, 
  delPreExamine,
  getPreExamineDoc,
  editCenterDoc,
  delCenterDoc,
  getCenterIpc,
  uploadCenterIpc,
  delCenterIpcData
} from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      docFormVisible: false, //控制文档管理界面显示预隐藏
      editDocFormVisible: false, //控制文档编辑界面显示预隐藏
      ipcFormVisible: false, //控制ipc界面显示预隐藏
      title: '',
      multipleSelection: [],
      infoForm: {
        id: '',
        name: '',
        city: '',
        area: '',
        address: '',
        tel: '',
        category: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel: wechatUrl + '/admin/guide/uploadCenterDoc',
      uploadIpc: wechatUrl + '/admin/guide/uploadCenterIpc',
      uploadIpcParam: {
        pre_id: ''
      },
      uploadDocParam: {
        id: '',
        city: ''
      },
      formInline: {
        page: 1,
        ps: 10,
        city: '',
        category: 0
      },
      listData: [], //用户数据
      docData: [], //文档资料数据
      ipcData: [], //ipc分类号数据
      docForm: {},
      editDocForm: {
        id: '',
        name: '',
        type: '',
        pre_id: '',
        url: ''
      },
      countryType: [
        { key: '全部', value: 0 },
        { key: '预审', value: 'pre' },
        { key: '优审', value: 'exc' }
      ],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
         // 表单验证
      infoFormRules: {
        name: [
          { required: true, message: '请输入中心名称', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请输入所属城市', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入开放领域', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请输入所属分类', trigger: 'blur' }
        ]
      },
      editDocFormRules: {
        name: [
          { required: true, message: '请输入文档名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入文档类型', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请上传文档', trigger: 'blur' }
        ],
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

     // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.editDocForm.url = response.data.url
          this.editDocForm.type = response.data.type
          this.editDocForm.pre_id = response.data.pre_id
          console.log(response)
          // this.excelFormVisible = false
          // this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    handleIpcSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          // 查询分类号
          this.getIpcData()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {

    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

        // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.flag = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },


    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getPreExaminePageList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 显示编辑页面
    handleEdit: function(index,row){
      if(row){
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        this.infoForm.city = row.city
        this.infoForm.area = row.area
        this.infoForm.address = row.address
        this.infoForm.tel = row.tel
        this.infoForm.category = row.category
        this.title = '编辑中心信息'
      }else{
        this.title = '添加中心信息'
        this.infoForm.id = ''
        this.infoForm.name = ''
        this.infoForm.city = ''
        this.infoForm.area = ''
        this.infoForm.address = ''
        this.infoForm.tel = ''
        this.infoForm.category = ''
      }
      this.editFormVisible = true
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 保存组织国家
    saveCountry(infoForm){
        //校验参数
      this.$refs[infoForm].validate(valid => {
        if(valid){
           editPreExamine(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false;
        }
      })
    },
    // 删除规费指引
    delCountry(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delPreExamine({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 文档管理
    handleDoc(index, row) {
      // 查询文档列表
      let pre_id = row.id
      let pre_city = row.city
      getPreExamineDoc({pre_id: pre_id})
      .then((res)=>{
        if(res.code == 200){
          this.docData = res.data
          this.title = '文档管理'
          this.docFormVisible = true
          this.uploadDocParam.id = pre_id
          this.uploadDocParam.city = pre_city
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      // 显示弹窗
    },
    // 文档编辑
    handleDocEdit(index ,row) {
      if(row){
        this.editDocForm.id = row.doc_id
        this.editDocForm.name = row.name
        this.editDocForm.type = row.type
        this.editDocForm.pre_id = row.pre_id
        this.editDocForm.url = row.url
        this.title = '文档编辑'
        this.editDocFormVisible = true
      }else{
        this.editDocForm.id = ''
        this.editDocForm.name = ''
        this.editDocForm.type = ''
        this.editDocForm.pre_id = this.pre_id
        this.editDocForm.url = ''
        this.title = '文档添加'
        this.editDocFormVisible = true
      }
    },
    // 保存文档资料
    saveDoc(editDocForm){
      this.$refs[editDocForm].validate(valid => {
        if(valid){
          editCenterDoc(this.editDocForm)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: '保存成功!'
                })
                this.editDocFormVisible = false
                this.getDocData()
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        }else{
          return false;
        }
      })
    },
    // 删除文档资料
    delCenterDoc(index,row){
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delCenterDoc({id: row.doc_id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getDocData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getDocData(){
      getPreExamineDoc({pre_id: this.uploadDocParam.id})
        .then((ret)=>{
          if(ret.code == 200){
            this.docData = ret.data
          }
        })
    },
    viewDoc(index,row){
      let url = row.pre_url
      window.open(url)
    },
    // 显示ipc分类号管理
    handleIpc(index,row){
      console.log(row)
      this.title = '分类号管理'
      this.ipcFormVisible = true
      getCenterIpc({pre_id: row.id})
      .then(res=>{
        if(res.code == 200){
          this.title = '分类号管理'
          this.ipcFormVisible = true
          this.uploadIpcParam.pre_id = row.id
          this.ipcData = res.data
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    getIpcData(){
      getCenterIpc({pre_id: this.uploadIpcParam.pre_id})
        .then((ret)=>{
          if(ret.code == 200){
            this.ipcData = ret.data
          }
        })
    },
    // 删除IPC分类号数据
    delIpcData(){
      let id = this.uploadIpcParam.pre_id
      // 是否确认删除
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delCenterIpcData({id: id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getIpcData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    closeEditDoc(){
      this.editDocFormVisible = false
    },
    // 类型
    typeFormat:function(row,column){
        if(row.category == 'pre'){
            return '预审'
        }else if(row.category == 'exc'){
            return '优审'
        }else{
            return '未知'
        }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #868484b5;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 180px;
  height: 96px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/PreCity.vue